// Drag-to-pan state
dragState = {
  isDragging: false,
  startX: 0,
  startY: 0,
  lastX: 0,
  lastY: 0,
  img: null,
};
class GaiaLightbox extends HTMLElement {
  constructor() {
    super();
    // Close lightbox events
    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape") {
        this.closeLightbox();
      }
    });
    document.querySelectorAll(".lightbox-close").forEach((element) => {
      element.addEventListener("click", () => {
        this.closeLightbox();
      });
    });

    // Listen for clicks in lightbox to activate zoom
    this.querySelectorAll("img").forEach((image) => {
      image.addEventListener("click", this.imageZoom.bind(this), {
        passive: true,
      });
    });
    // If slide changes, zoom out
    this.querySelectorAll(".swiper-button").forEach((button) => {
      button.addEventListener("click", () => {
        this.zoomOutAll();
      });
    });
  }

  openLightbox(t) {
    // Show lightbox
    this.style.display = "block";
    // Lower brands-navigation z-index when lightbox is open
    const brandsNav = document.querySelector(".brands-navigation");
    if (brandsNav) {
      brandsNav.style.zIndex = "10";
    }
    // Match the lightbox slide to the active slide on product gallery
    var gallery = document.getElementById(t);

    // If the gallery is a swiper itself (e.g product gallery)
    var activeSlide = gallery.querySelector(".swiper-slide-active");
    if (activeSlide) {
      var slideIndex = activeSlide.getAttribute("data-swiper-slide-index");
      this.swiper.slideTo(slideIndex, 0);
      // If its built of blocks, blocks should be assigned a data-swiper-slide-index to pull in here
    } else {
      var selectedSlideParent = event.target.closest(".lightbox-item");
      var slideIndex = selectedSlideParent.getAttribute(
        "data-swiper-slide-index"
      );
      this.swiper.slideTo(slideIndex, 0);
    }

    document.body.classList.add("overflow-hidden");
    document.addEventListener("keydown", this.focusLightbox.bind(this), {
      passive: true,
    });
  }

  closeLightbox() {
    this.style.display = "none";
    this.zoomOutAll();
    document.body.classList.remove("overflow-hidden");
    document.removeEventListener("keydown", this.focusLightbox.bind(this));
    // Restore brands-navigation z-index when lightbox is closed
    const brandsNav = document.querySelector(".brands-navigation");
    if (brandsNav) {
      brandsNav.style.zIndex = "50";
    }
  }

  imageZoom(e) {
    // Check if zoom is disabled
    if (
      e.target.classList.contains("zoom-disabled") ||
      e.target.classList.contains("video-poster")
    ) {
      return;
    }
    // Scale image by 2 (set in CSS)
    e.target.classList.toggle("zoomed-in");
    if (e.target.classList.contains("zoomed-in")) {
      // Set transform-origin to the point of click (only once)
      this.setOrigin(e);

      // Reset pan position
      e.target.style.transition = "scale 0.3s ease-in-out, translate 0.2s";
      e.target.style.translate = "0px 0px";

      // Add drag-to-pan listeners
      e.target.addEventListener("mousedown", this.startPan.bind(this));
      e.target.addEventListener("touchstart", this.startPan.bind(this), {
        passive: false,
      });
    } else {
      // Reset transform-origin when zooming out
      e.target.style.transformOrigin = "";

      // Reset pan position
      e.target.style.transition = "";
      e.target.style.translate = "";

      // Remove drag-to-pan listeners
      e.target.removeEventListener("mousedown", this.startPan.bind(this));
      e.target.removeEventListener("touchstart", this.startPan.bind(this));
    }
  }

  startPan(e) {
    e.preventDefault();
    const img = e.target;
    this.dragState.isDragging = true;
    this.dragState.img = img;
    if (e.type === "touchstart") {
      this.dragState.startX = e.touches[0].clientX;
      this.dragState.startY = e.touches[0].clientY;
    } else {
      this.dragState.startX = e.clientX;
      this.dragState.startY = e.clientY;
    }
    this.dragState.lastX = 0;
    this.dragState.lastY = 0;
    document.addEventListener("mousemove", this.panImage);
    document.addEventListener("mouseup", this.endPan);
    document.addEventListener("touchmove", this.panImage, { passive: false });
    document.addEventListener("touchend", this.endPan);
    document.body.style.cursor = "grab";
  }

  panImage = (e) => {
    if (!this.dragState.isDragging || !this.dragState.img) return;
    let clientX, clientY;
    if (e.type === "touchmove") {
      clientX = e.touches[0].clientX;
      clientY = e.touches[0].clientY;
    } else {
      clientX = e.clientX;
      clientY = e.clientY;
    }
    let dx = clientX - this.dragState.startX + this.dragState.lastX;
    let dy = clientY - this.dragState.startY + this.dragState.lastY;
    this.dragState.img.style.translate = `${dx}px ${dy}px`;
  };

  endPan = (e) => {
    if (!this.dragState.isDragging || !this.dragState.img) return;
    let clientX, clientY;
    if (e.type === "touchend") {
      if (e.changedTouches && e.changedTouches.length > 0) {
        clientX = e.changedTouches[0].clientX;
        clientY = e.changedTouches[0].clientY;
      } else {
        clientX = this.dragState.startX;
        clientY = this.dragState.startY;
      }
    } else {
      clientX = e.clientX;
      clientY = e.clientY;
    }
    this.dragState.lastX += clientX - this.dragState.startX;
    this.dragState.lastY += clientY - this.dragState.startY;
    this.dragState.isDragging = false;
    document.removeEventListener("mousemove", this.panImage);
    document.removeEventListener("mouseup", this.endPan);
    document.removeEventListener("touchmove", this.panImage);
    document.removeEventListener("touchend", this.endPan);
    document.body.style.cursor = "";
  };

  zoomOutAll() {
    // If clicked whilst zoomed in, zoom out
    this.querySelectorAll("img").forEach((image) => {
      image.classList.remove("zoomed-in");
      image.style.translate = "";
    });
  }

  setOrigin(e) {
    // Allows for moving around image whilst zoomed in
    let rect = e.target.getBoundingClientRect();
    let x = e.clientX - rect.left;
    let y = e.clientY - rect.top;
    let w = rect.width;
    let h = rect.height;
    let left = Math.min(Math.max(Number(((x / w) * 100).toFixed(1)), 0), 100);
    let top = Math.min(Math.max(Number(((y / h) * 100).toFixed(1)), 0), 100);
    e.target.style.transformOrigin = `${left}% ${top}%`;
  }

  //   Accessibility controls
  focusLightbox(event) {
    var focusableEls = this.querySelectorAll(".lightbox-close, .swiper-button");
    var firstFocusableEl = focusableEls[0];
    var lastFocusableEl = focusableEls[focusableEls.length - 1];

    if (event.key === "Tab") {
      if (event.shiftKey) {
        /* shift + tab */ if (document.activeElement === firstFocusableEl) {
          lastFocusableEl.focus();
          event.preventDefault();
        }
      } /* tab */ else {
        if (document.activeElement === lastFocusableEl) {
          firstFocusableEl.focus();
          event.preventDefault();
        }
      }
    }
  }
}

function openLightbox(t, e) {
  t.preventDefault();
  var lightbox = document.getElementById(e);
  if (lightbox && typeof lightbox.openLightbox === "function") {
    lightbox.openLightbox(e);
  }
}

customElements.define("gaia-lightbox", GaiaLightbox);
